export default __webpack_public_path__ + "static/espressif-cea86c53307cb1cb891e849a3cc36aec.png";